import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Link } from 'gatsby';

import Button from '@components/atoms/Button';

import { useTrackEvent } from '@hooks/useTrackEvent';

import { Wrapper } from './styled';

const Buttons = () => {
  const trackEvent = useTrackEvent();

  return (
    <Wrapper>
      <Button
        size="small"
        as="a"
        href="https://buy.bitcoin.com/verse/"
        target="_blank"
        rel="noreferrer"
        onClick={() =>
          trackEvent('tap', {
            to: 'https://buy.bitcoin.com/verse/',
          })
        }
      >
        <FormattedMessage id="lounge.noVerse.buy" />
      </Button>
      <Button
        size="small"
        design="secondary"
        as={Link}
        to="/swap/"
        onClick={() =>
          trackEvent('tap', {
            to: 'https://verse.bitcoin.com/swap/',
          })
        }
      >
        <FormattedMessage id="lounge.noVerse.swap" />
      </Button>
    </Wrapper>
  );
};

export default Buttons;
